var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pl-1" },
    [
      _vm.ssr
        ? _vm._t("body")
        : [
            _vm.quarters != null
              ? _vm._l(_vm.quarters, function(quarter) {
                  return _c(
                    "span",
                    {
                      key: quarter.title,
                      class: "badge badge-" + _vm.$root.network
                    },
                    [_vm._v(_vm._s(quarter["title"]))]
                  )
                })
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }